import { useNotificationCheckQuery, useNotificationsQuery } from './notifications.services'

export const useNotificationSync = () => {
  // Prefetch notification list
  useNotificationsQuery()

  // Initialize periodic check (also handles initial badge count)
  useNotificationCheckQuery()
}
